import { GoClock } from "react-icons/go";

// ENG-2045: what the clinic admin sees on their own link after signing their
// part of the Rx agreement. The link was handed to the MD under a new secret,
// so this page has no document to show; the wording is product's.
const AwaitingNextSigner = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen gap-4">
      <div className="flex flex-col items-center justify-center h-full gap-8">
        <GoClock
          size={160}
          className="text-white bg-blue-400 p-4 rounded-full"
        />
        <div className="text-3xl text-center font-semibold">
          Your portion is complete.
        </div>
        <div className="text-xl text-center">
          This agreement is awaiting your medical director’s signature.
        </div>
      </div>
    </div>
  );
};

export default AwaitingNextSigner;
